import { FC } from "react";

export const TokushohoPage: FC = () => {
  return (
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 py-8">
      <h1 className="text-xl font-bold text-gray-700 mb-8">特定商取引法に基づく表示</h1>
      <h2 className="text-md font-bold text-gray-700 mt-8 mb-4">1. 事業者の名称</h2>
      <p className="text-md text-gray-700 mb-4">株式会社WeCanDoIt</p>
      <h2 className="text-md font-bold text-gray-700 mt-8 mb-4">2. 運営責任者</h2>
      <p className="text-md text-gray-700 mb-4"> 代表取締役 大里健祐</p>
      <h2 className="text-md font-bold text-gray-700 mt-8 mb-4">3. 所在地</h2>
      <p className="text-md text-gray-700 mb-4">東京都練馬区氷川台3-39-5 森田ビル1階</p>
      <h2 className="text-md font-bold text-gray-700 mt-8 mb-4">4. 連絡先</h2>
      <table>
        <thead>
        <tr>
          <th className="text-left text-md font-bold text-gray-700 py-2 pr-8">連絡方法</th>
          <th className="text-left text-md font-bold text-gray-700 py-2 pr-8">連絡先</th>
          <th className="text-left text-md font-bold text-gray-700 py-2">受付時間</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td className="text-md text-gray-700 py-2 pr-8">電話</td>
          <td className="text-md text-gray-700 py-2 pr-8">050-1721-5932</td>
          <td className="text-md text-gray-700 py-2">平日10:30～12:00、13:00～17:00<br />（当社指定の休日を除く。）</td>
        </tr>
        <tr>
          <td className="text-md text-gray-700 py-2 pr-8">メール</td>
          <td className="text-md text-gray-700 py-2 pr-8">contact@wcdi.co.jp</td>
          <td className="text-md text-gray-700 py-2">終日</td>
        </tr>
        </tbody>
      </table>
      <h2 className="text-md font-bold text-gray-700 mt-8 mb-4">5. 商品代金</h2>
      <p className="text-md text-gray-700 mb-4">
        サービスの利用申込ページ上で表示されたサービス利用料金による販売となります。 <br />
        ※サービス利用料金には、商品の売買代金、配送料が含まれます。
      </p>
      <h2 className="text-md font-bold text-gray-700 mt-8 mb-4">6. 商品代金以外に必要となる費用</h2>
      <p className="text-md text-gray-700 mb-4">
        ・利用者の指定した日時、場所に利用者が不在であった場合、指定場所が不存在または不明であった場合等、
        利用者側の理由で商品の引き渡しができなかった場合、再配達のために別途当社の定める再配達手数料の支払義務が発生します。<br />
        ・お申込み等にかかる通信費
      </p>
      <h2 className="text-md font-bold text-gray-700 mt-8 mb-4">7. 商品代金の支払方法及び支払時期</h2>
      <p className="text-md text-gray-700 mb-4">
        【支払方法】<br />
        次の支払い方法をご利用いただけます。<br /><br />
        ・クレジットカード<br /><br />
        【支払時期】
      </p>
      <table>
        <thead>
        <tr>
          <th className="text-left text-md font-bold text-gray-700 py-2 pr-8">支払方法</th>
          <th className="text-left text-md font-bold text-gray-700 py-2">支払日</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td className="text-md text-gray-700 py-2 pr-8">クレジットカード</td>
          <td className="text-md text-gray-700 py-2">クレジットカード会社の会員規約で定められた振替日</td>
        </tr>
        </tbody>
      </table>
      <h2 className="text-md font-bold text-gray-700 mt-8 mb-4">8. 商品引渡時期</h2>
      <p className="text-md text-gray-700 mb-4">サービスの利用申込ページ上で表示された日時、場所に注文商品をお届けいたします。</p>
      <h2 className="text-md font-bold text-gray-700 mt-8 mb-4">9. ご利用者様からの注文のキャンセル</h2>
      <p className="text-md text-gray-700 mb-4">
        ご利用者様は、当社が別途定める期間内に限り、注文のキャンセルを行うことができますが、
        当社が別途定める期間を経過した後については、ご利用者様からのキャンセルをお請けすることはできません
        （利用料金が既に支払い済みであったとしても、返金に応じることはできません。）。
      </p>
      <h2 className="text-md font-bold text-gray-700 mt-8 mb-4">10. 返金、交換</h2>
      <p className="text-md text-gray-700 mb-4">
        ・注文商品の引き渡し時に品違い、数量不足、破損等が判明した場合、当社の費用負担において代替品または追加分の納品を行います。<br />
        ・注文商品の引き渡し後に、当該商品についての数量不足、破損等の瑕疵が問題となった場合、当社において当該瑕疵が引き渡し前に生じたものであると確認することができた場合に限り、注文商品の交換またはキャンセルを承ることとします。ただし、商品の引き渡し完了後、２週間が経過した場合はいかなる対応もいたしません。<br />
        ・通信販売の性質上クーリングオフの適用はありません。
      </p>
      <h2 className="text-md font-bold text-gray-700 mt-8 mb-4">11. 当社からのキャンセル</h2>
      <p className="text-md text-gray-700 mb-4">
        当社において注文商品の在庫を確保することできない場合には、当社より個別契約の全部または一部をキャンセルさせていただきます。
        キャンセル分の商品について、既にご利用者様から当社に対して支払いがなされていた場合、
        当社よりご利用者様に対して当該キャンセル分の利用料金の返金を行います。
      </p>
      <h2 className="text-md font-bold text-gray-700 mt-8 mb-4">12. 酒類販売管理者標識</h2>
      <p className="text-md text-gray-700 mb-4">
        （販売場の名称及び所在地）<br />
        東京都練馬区氷川台3-39-5 森田ビル1階 東京城西店<br />
        （酒類販売管理者の氏名）大里 健祐<br />
        （酒類販売管理研修受講年月日）令和8年1月30日<br />
        （次回研修の受講期限）令和11年1月29日<br />
        （研修実施団体名）一般社団法人 日本ボランタリーチェーン協会<br />
      </p>
    </div>
  );
};
